import * as React from "react";
import type { SVGProps } from "react";
const SvgBedSheets = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M16.38 3c2.58 0 4.72 1.93 4.98 4.5l.64 3.38a1.007 1.007 0 0 1-1.31 1.07c.82.96 1.31 2.2 1.31 3.55 0 3.03-2.47 5.5-5.5 5.5h-9A5.51 5.51 0 0 1 2 15.5v-2.6l.75-5.28C2.93 5.04 5.12 3 7.73 3zM7.73 5C6.16 5 4.85 6.22 4.74 7.79L4 13.05v2.45C4 17.43 5.57 19 7.5 19h9c1.93 0 3.5-1.57 3.5-3.5S18.43 12 16.5 12h-8c-1.1 0-2 .9-2 2s.9 2 2 2H16c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H9c-.55 0-1-.45-1-1s.45-1 1-1h7a2.5 2.5 0 0 1 0 5H8.5c-2.21 0-4-1.79-4-4s1.79-4 4-4h8c1.37 0 2.62.5 3.58 1.33-.03-.07-.07-.13-.07-.21l-.64-3.4A3 3 0 0 0 16.38 5z"
    />
  </svg>
);
export default SvgBedSheets;
